import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { IOnClick, IOptionsItem } from '../FilterContainer';
import { deviceMaxWidth, deviceMinWidth } from '../../constants';
import { getFilterItemName, getFilterTitle } from '../../utils/helpers';

export default function FilterItem(
  props: IOptionsItem & {
    name: string;
    title?: string;
    isChapterFilterItem?: boolean;
  } & IOnClick,
) {
  const {
    text,
    name,
    title,
    value,
    selected,
    onClickFilter,
    isChapterFilterItem,
  } = props;
  const isTitleComponent = !!title;
  const isCountry = name === 'country';
  const styles = useStyles({ isTitleComponent, selected, isChapterFilterItem, isCountry });

  const clickTitle = () => {
    console.log('title: ', title, 'n: ', name, [name]);
  };

  const clickOptionItem = () => {
    const data = {
      [name]: value,
    };
    onClickFilter && onClickFilter(data);
  };

  const onClickHandler = () =>
    isTitleComponent ? clickTitle() : clickOptionItem();

  const titleText = isTitleComponent
    ? getFilterTitle(title)
    : getFilterItemName(text, name);

  return (
    <div className={styles.filterItem} onClick={onClickHandler}>
      {titleText}
    </div>
  );
}

const useStyles = makeStyles<
  Theme,
  {
    isTitleComponent: boolean;
    selected: boolean;
    isChapterFilterItem?: boolean;
    isCountry?: boolean;
  }
>((theme) => ({
  filterItem: {
    display: 'flex',
    justifyContent: (props) =>
      props.isTitleComponent ? 'center' : 'flex-start',
    padding: '10px 20px',
    backgroundColor: (props) =>
      props.isTitleComponent
        ? 'rgba(222, 146, 77, 0.7)'
        : props.selected
        ? '#FEDDBE'
        : '#FFECDB',
    color: '#603004',
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: (props) => (props.isTitleComponent ? 500 : 400),
    borderRadius: 5,
    margin: '0 2px 4px 2px',
    cursor: 'pointer',
    width: (props) => (props.isChapterFilterItem ? '47%' :
      (props.isCountry && !props.isTitleComponent) ? '96%' :'100%'),
    '&:hover': {
      background: (props) =>
        !props.isTitleComponent ? '#FEDEC2' : '',
    },

    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size2560]: {
        minWidth: (props) => (props.isChapterFilterItem ? 165 / 2 : 165),
      },
    },
    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size1300]: {
        minWidth: (props) => (props.isChapterFilterItem ? 120 / 2 : 120),
      },
    },
    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        minWidth: (props) => (props.isChapterFilterItem ? 100 / 2 : 100),
      },
    },

    [deviceMaxWidth.size500]: {
      width: '100%',
    },
  },

  boxContainer: {
    minHeight: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
